import styled from 'styled-components';

export const TabsContainer = styled.nav`
    padding: 0;
    display: flex;
    width: 100%;
    overflow-x: auto;
    scroll-behavior: smooth;
    box-sizing: content-box;
    flex: 1 0 auto;
    scrollbar-width: none; //NOSONAR
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
`;

export const Tabs = styled.ul`
    display: flex;
    height: fit-content;
    align-items: center;
    min-height: 50px;
    max-height: 70px;
`;
